(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('sodProfileScoreBreakdown', sodProfileScoreBreakdown);

    function sodProfileScoreBreakdown() {
        return {
            restrict: 'E',
            scope: {
                scoreBreakdown: "="
            },
            controller: sodProfileScoreBreakdownCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'tms/templates/jobs/score-breakdown'
        };
    }

    function sodProfileScoreBreakdownCtrl() {}
})();